import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useGetDispatchHistory } from "../../../utils/react-query/queryDispatches/queries";

interface DispatchHistoryModalProps {
  dispatchId: number | null;
  onClose: () => void;
}

function formatDateTime(isoString: string) {
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("es-CO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function DispatchHistoryModal({
  dispatchId,
  onClose,
}: DispatchHistoryModalProps) {
  const { data, isLoading } = useGetDispatchHistory({
    dispatch_id: dispatchId ?? 0,
  });

  if (dispatchId == null) return null;

  const results = data?.results ?? [];

  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        disableTypography
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6">
          Historial del despacho #{dispatchId}
        </Typography>
        <IconButton size="small" onClick={onClose} aria-label="cerrar">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {isLoading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "2rem",
            }}
          >
            <CircularProgress size={32} />
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ marginLeft: 12, alignSelf: "center" }}
            >
              Cargando historial...
            </Typography>
          </div>
        )}

        {!isLoading && results.length === 0 && (
          <Typography
            variant="body2"
            color="textSecondary"
            align="center"
            style={{ padding: "2rem" }}
          >
            No hay historial registrado para este despacho.
          </Typography>
        )}

        {!isLoading && results.length > 0 && (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Acción</strong>
                </TableCell>
                <TableCell>
                  <strong>Estado</strong>
                </TableCell>
                <TableCell>
                  <strong>Realizado por</strong>
                </TableCell>
                <TableCell>
                  <strong>Fecha</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {results.map((entry) => (
                <TableRow key={entry.id}>
                  <TableCell>{entry.action}</TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    {entry.status_from ?? "—"} → {entry.status_to ?? "—"}
                  </TableCell>
                  <TableCell>
                    {entry.performed_by_name || (
                      <Typography
                        variant="body2"
                        component="span"
                        color="textSecondary"
                      >
                        —
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    {formatDateTime(entry.created_at)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default DispatchHistoryModal;
